import { checkTheme, Themes } from "carrier-fe";
import { CSSProperties } from "react";

const LOGO_WIDTH_DEFAULT = 128;
const LOGO_WIDTH_TOSHIBA = 180;

const TABLET_BREAKPOINT = 768;

const LOGO_POSITION_OFFSET = 10;

export const logoStyle: CSSProperties = {
  width: checkTheme(Themes.Toshiba) ? LOGO_WIDTH_TOSHIBA : LOGO_WIDTH_DEFAULT,
  ...checkTheme(Themes.Toshiba) && {
    position: 'fixed',
    top: LOGO_POSITION_OFFSET,
    left: window.innerWidth > TABLET_BREAKPOINT ? LOGO_POSITION_OFFSET : 'auto',
  }
};